import axios from 'axios';

import { ENV } from './config';

const devURL = 'https://staffing-be-dev.azurewebsites.net';

axios.defaults.baseURL = `${ ENV.API_URL || devURL }/api/`;
export default axios;


export const getHolidays = async (year, countryCode = 'swe') => {
    try {
        const url = 'https://kayaposoft.com/enrico/json/v2.0/?action=getHolidaysForYear'+
        `&year=${ year }&country=${ countryCode }`+
        '&holidayType=public_holiday';

        const res = await axios.get(url);

        let result = [];

        res.data.forEach(d => result.push(new Date(Date.UTC(d.date.year, d.date.month-1, d.date.day))));

        return result;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('getHolidays failed', e);

        return null;
    }
};

export const getVersion = async () => {
    const feVersion = ENV.VITE_GIT_COMMIT_HASH;
    let beVersion;

    try {
        const { data } = await axios.get('/ServerInfo');
        beVersion = data.backendVersion;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
    }

    if (!feVersion || feVersion.length > 8) {
        if (!beVersion) {
            //no versions
            return '-';
        } else {
            //just BE version
            return `-/${ beVersion }`;
        }
    } else {
        if (!beVersion) {
            //just FE version
            return feVersion;
        } else {
            //both versions
            return `${ feVersion }/${ beVersion }`;
        }
    }
};
